(ns manatee.admin.task-config.edit.view
  "The admin. task configuration edit form.
   Allows administrators and project owners to edit existing task
   configurations."
  (:require
   [manatee.admin.rejection-option.subs :as rejection-subs]
   [manatee.admin.subs :as subs]
   [manatee.admin.task-config.edit.handlers :as handlers]
   [manatee.admin.task-config.form-components :as form-components]
   [manatee.admin.task-config.subs :as task-config-subs]
   [manatee.admin.task-config.view :as task-config-view]
   [manatee.admin.view :as admin-view]
   [manatee.components.notifications.container :as notifications]
   [manatee.domain.task :as task-domain]
   [manatee.ui.templates :as templates]
   [manatee.user.subs :as user-subs]
   [re-frame.core :as rf]
   [rothko.layout.component :refer [layout]]
   [rothko.panel.component :refer [panel]]))

(defn- edit-task-button
  []
  {:button {:appearance #{:primary}
            :class [:task-page__submit-button]
            :id :submit-btn}
   :label "Edit Task"})

(defn- edit-task-form
  [{:keys [!uploaded-submissions] :as props} {:keys [id task-name data team-id] {:keys [modifiers]} :data :as task-config}]
  (let [form-values {:id id
                     :task-name task-name
                     :team-id team-id
                     :source-value (form-components/data->account-id-key data)
                     :type-value (form-components/data->type-option-key data)
                     :part-score-type-value (form-components/data->part-score-type-key data)
                     :answer-score-type-value (form-components/data->answer-score-type-key data)
                     :assessment-name-value (form-components/data->assessment-name-key data)
                     :scoring-criteria-value (form-components/data->scoring-criteria-keys data (form-components/scoring-criteria-options))
                     :score-range (let [[score-range-from score-range-to] (form-components/score-range-from-to task-config)]
                                    {:from score-range-from :to score-range-to})
                     :part-rejection-value (form-components/data->part-score-type-keys data)
                     :answer-rejection-value (form-components/data->answer-score-type-keys data)
                     :first-stage-rejections-value (form-components/keywords->options (:first-stage-rejections data) task-domain/first-stage-rejections-values)
                     :next-stage-part-rejections-value (form-components/keywords->options (:next-stage-part-rejections data) task-domain/next-stage-part-rejections-values)
                     :next-stage-answer-rejections-value (form-components/keywords->options (:next-stage-answer-rejections data) task-domain/next-stage-answer-rejections-values)
                     :custom-validation-rules-value (form-components/keywords->options (:custom-validation-rules modifiers) task-domain/custom-validation-rules)
                     :modifiers modifiers}]
    (task-config-view/task-form props
                                form-values
                                {:form-name :task-details-form
                                 :submit-button (edit-task-button)
                                 :on-submit (fn [form-values reset-submitting-flag]
                                              (rf/dispatch [::handlers/edit-task form-values @!uploaded-submissions reset-submitting-flag]))})))

(defn task-config-container
  [props]
  (let [admin? @(rf/subscribe [::user-subs/admin?])
        project-owner? @(rf/subscribe [::user-subs/project-owner?])
        user-teams @(rf/subscribe [::subs/user-teams])
        task-config-id @(rf/subscribe [::task-config-subs/task-config-id])
        task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])
        task-part-rejection-options (get-in task-config [:data :part :rejections :reasons] [])
        task-answer-rejection-options (get-in task-config [:data :answer :rejections :reasons] [])
        existing-task-names @(rf/subscribe [::task-config-subs/task-config-names])
        part-rejection-options-speech @(rf/subscribe [::rejection-subs/select-rejection-options :part :speech])
        part-rejection-options-text @(rf/subscribe [::rejection-subs/select-rejection-options :part :text])
        answer-rejection-options-speech @(rf/subscribe [::rejection-subs/select-rejection-options :answer :speech])
        answer-rejection-options-text @(rf/subscribe [::rejection-subs/select-rejection-options :answer :text])]
    (if (or admin? project-owner?)
      [:<>
       [notifications/alerts {:banner-id :main
                              :max-alerts 1}]
       [panel {:appearance #{:primary}
               :class [:task-page__panel]}
        [layout {:appearance #{:column}
                 :class [:task-page__form-layout]}
         [:h2 "Edit task"]
         [edit-task-form
          (merge props
                 {:sources task-domain/sources
                  :user-teams user-teams
                  :project-owner? project-owner?
                  :part-score-types task-domain/part-score-types
                  :answer-score-types task-domain/answer-score-types
                  :types task-domain/types
                  :!uploaded-submissions (atom nil)
                  :part-rejection-options-speech (task-domain/merge-rejection-options part-rejection-options-speech task-part-rejection-options)
                  :part-rejection-options-text (task-domain/merge-rejection-options part-rejection-options-text task-part-rejection-options)
                  :answer-rejection-options-speech (task-domain/merge-rejection-options answer-rejection-options-speech task-answer-rejection-options)
                  :answer-rejection-options-text (task-domain/merge-rejection-options answer-rejection-options-text task-part-rejection-options)
                  :existing-task-names (set existing-task-names)
                  :existing-task? true})
          task-config]]]]
      [admin-view/access-denied props])))

(def edit-task-page
  {:main task-config-container
   :template templates/single-column})
